import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '@rd/core/services/date/date.service';

@Pipe({
  name: 'localizeDate',
  pure: false,
  standalone: false,
})
export class LocalizeDatePipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  public transform(
    value: string | number | Date,
    format: string,
    timezone?: string,
  ): string {
    return this.dateService.formatDate(value, format, timezone);
  }
}
